export const item = `[&>a]:transition-colors [&>a]:text-primary-100 [&>a]:hover:text-primary-200`;
export const label = `font-semibold`;
export const rating = `py-0 px-2 ml-1 text-xs rounded-md font-bold text-white bg-primary-100`;
